import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

// One colour to a unit, in the order the family ranks them — best complying first.
const INK = [
  "hsl(199 89% 48%)",
  "hsl(var(--healthy))",
  "hsl(var(--watch))",
  "hsl(var(--at-risk))",
  "hsl(262 83% 58%)",
  "hsl(28 80% 52%)",
  "hsl(var(--primary))",
];

/**
 * One family's cumulative compliance over time — one line per unit, read by calendar date.
 *
 * The units do not start together, so a line simply begins where that unit's first reading is.
 * `connectNulls` carries a line across a day the unit filled nothing, which is the truth of a
 * cumulative figure: it does not move until another reading arrives.
 */
export const FamilyTrendChart = ({ series = [], lines = [], height = 240, testId }) => (
  <div className="w-full min-w-[280px]" style={{ height }} data-testid={testId}>
    <ResponsiveContainer width="100%" height={height} minWidth={280} debounce={40}>
      <LineChart data={series} margin={{ top: 8, right: 10, left: -20, bottom: 0 }}>
        <CartesianGrid stroke="hsl(var(--border))" vertical={false} />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 10, fontFamily: "IBM Plex Mono" }}
          tickFormatter={(d) => String(d).slice(5)}
          stroke="hsl(var(--muted-foreground))"
          minTickGap={24}
        />
        <YAxis
          domain={[0, 120]}
          tickFormatter={(v) => `${v}%`}
          tick={{ fontSize: 10, fontFamily: "IBM Plex Mono" }}
          stroke="hsl(var(--muted-foreground))"
        />
        <Tooltip
          contentStyle={{
            background: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: 0,
            fontSize: 12,
          }}
          formatter={(v) => (v === null || v === undefined ? "—" : `${v}%`)}
        />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        {lines.map((line, i) => (
          <Line
            key={line.key}
            type="monotone"
            dataKey={line.key}
            name={`${line.key} — cumulative %`}
            stroke={INK[i % INK.length]}
            strokeWidth={2}
            dot={false}
            connectNulls
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  </div>
);
